import React from 'react';
import { makeStyles } from '@material-ui/core';
import { clsx, colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { documentDateFormat } from '@utils/formatter';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

interface Props {
  isLatest?: boolean;
  isRejected?: boolean;
  createdAt: string;
}
const PurchaseOrderHistoryBar = ({
  isLatest = false,
  isRejected = false,
  createdAt
}: Props) => {
  const classes = useStyles();

  return (
    <div
      className={clsx('purchaseorder-history', classes.root, {
        latest: isLatest,
        rejected: isRejected
      })}
    >
      {isRejected && (
        <CustomizedTypography
          variant="subtitle2"
          color={'error'}
          className="error"
        >
          <InfoOutlined /> 발주서가 거부되었습니다. 파트너와 협의 후 새로운
          발주서를 발행해주세요.
        </CustomizedTypography>
      )}

      {!isRejected && isLatest && (
        <CustomizedTypography
          align="center"
          variant="subtitle2"
          color={'primary'}
        >
          {documentDateFormat(new Date(createdAt ?? 0).toString())}에 발행된
          최신견적서를 바탕으로 작성합니다.
        </CustomizedTypography>
      )}

      {!isRejected && !isLatest && (
        <>
          <CustomizedTypography
            align="center"
            variant="subtitle2"
            color={'inherit'}
          >
            {documentDateFormat(new Date(createdAt ?? 0).toString())}에 발행된
            견적서를 바탕으로 작성합니다.
          </CustomizedTypography>
        </>
      )}
    </div>
  );
};

export default PurchaseOrderHistoryBar;

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colorSet.gray100,
    borderRadius: 8,
    padding: 12,
    '& h6': {
      width: '100%'
    },
    '& svg': {
      marginRight: 8,
      width: 20,
      height: 20
    },
    '&.latest': {
      backgroundColor: colorSet.primary100
    },
    '&.rejected': {
      backgroundColor: colorSet.errorBackGround,
      '& .error': {
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
}));
